import { appGetState } from 'legacy/lut/store'

import { isNetworkDebugUser, recordNetworkDebugCall } from 'shared/lib/networkDebug'

type TAcknowledgmentCallStart = {
  name: string
  method: string
  url: string
  body: unknown
  /** Where the caller keeps the result. */
  target: string
  /** From `useNetworkDebugSource()` of the hook that makes the call. */
  source?: string | null
}

/** Shows an acknowledgment request in the Super Admin's network data window. */
export const recordAcknowledgmentCall = <TRaw, TResult = TRaw>(
  { source = null, ...start }: TAcknowledgmentCallStart,
  request: () => Promise<TRaw>,
  map?: (raw: TRaw) => TResult
) =>
  recordNetworkDebugCall(
    {
      ...start,
      source,
      enabled: isNetworkDebugUser(appGetState().user?.roleIds),
      headers: {},
    },
    request,
    map
  )
